import {
  combine,
  withCallbacks,
  withContext,
  withMemo,
} from 'react-hooks-combine'
import { withRouter } from 'react-router-dom'

import { withTableController } from 'shared/hooks'
import { ServicesContext } from 'services/context'
import { team as teamRoutes } from 'routes/route.map'

import TeamOverviewComponent from './component'
import { createColumns } from './columns.description'

export const TeamOverview = combine({
  hocs: [withRouter],
  hooks: [
    withTableController({ id: 'teams-table' }),
    withContext(
      'teamService',
      ServicesContext,
      ({ teamService }) => teamService
    ),
    withCallbacks(
      {
        getTrProps:
          (_state, { history }) =>
          (_state, rowInfo) => {
            const teamId = rowInfo?.original?.id

            return {
              style: { cursor: 'pointer' },
              onClick() {
                history.push(teamRoutes.view(teamId))
              },
            }
          },

        loadTeams:
          ({ teamService }) =>
          (tableState, _table, search = '') =>
            teamService.query({
              page: tableState.page,
              size: tableState.pageSize,
              teamName: search,
            }),

        onSearch:
          ({ table }) =>
          (query) => {
            table.search(query)
          },
      },
      []
    ),
    withMemo('columns', () => createColumns(), []),
  ],
})(TeamOverviewComponent)
